export default __webpack_public_path__ + "static/media/Discord.b107b672.svg";